import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { BlockListSpot } from '@features/spots/umbraco-block-list-spot/block-list-spot.models';
import { AddIndexToSpotDataPipe } from './add-index-to-spot-data.pipe';
import { GenericBlockListSpotDirective } from './block-list-spot-generic.directive';
import { IntersectionAnimateDirective } from '@shared/intersection/intersection-animation/intersection-animation.directive';
import { NgFor } from '@angular/common';

@Component({
    selector: 'app-block-list-spots',
    template: `
        <div class="block-list-base-spot" *ngFor="let spot of spots; let i = index" [index]="i" appIntersectionAnimate>
            <div
                appGenericBlockListSpot
                [spotType]="spot.alias"
                [spotData]="spot | addIndexToSpotData: i"
                [theme]="theme"
            ></div>
        </div>
    `,
    styleUrls: ['./block-list-spots.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgFor, IntersectionAnimateDirective, GenericBlockListSpotDirective, AddIndexToSpotDataPipe]
})
export class BlockListSpotsComponent {
    @Input()
    spots: BlockListSpot[];

    @Input()
    theme?: string;
}
